export const IMAGE_MODELS = [
  {
    key: 'dall-e-3',
    name: 'DALL·E 3',
    provider: 'AvalAI',
    badge: 'حرفه ای',
    ownedBy: 'openai',
    category: 'image_generation',
    supportsImage: true,
    descriptionFa: 'کیفیت بالا برای ساخت تصویر تبلیغاتی و هنری',
    descriptionEn: 'High quality images for ads and creative work'
  },
  {
    key: 'gpt-image-1',
    name: 'GPT Image',
    provider: 'AvalAI',
    badge: 'متوسط',
    ownedBy: 'openai',
    category: 'image_generation',
    supportsImage: true,
    descriptionFa: 'ساخت تصویر سریع با درک بهتر پرامپت',
    descriptionEn: 'Fast image generation with strong prompt understanding'
  }
];

export const DEFAULT_IMAGE_MODEL_KEY = 'dall-e-3';
export const DEFAULT_IMAGE_EDIT_MODEL_KEY = 'gpt-image-1';

export const CHAT_MODELS = [
  {
    key: 'gpt-5.5',
    name: 'GPT-5.5',
    provider: 'AvalAI',
    badge: 'حرفه ای',
    ownedBy: 'openai',
    category: 'chat',
    supportsImage: false,
    descriptionFa: 'قوی‌ترین مدل گفتگو برای پاسخ‌های دقیق و عمیق',
    descriptionEn: 'Most capable chat model for precise and deep answers'
  },
  {
    key: 'gpt-5.3-codex',
    name: 'GPT 5.3 Codex',
    provider: 'AvalAI',
    badge: 'متوسط',
    ownedBy: 'openai',
    category: 'chat',
    supportsImage: false,
    descriptionFa: 'مناسب گفتگوی عمومی با تعادل سرعت و کیفیت',
    descriptionEn: 'Balanced general chat with good speed and quality'
  },
  {
    key: 'dall-e-3',
    name: 'DALL·E 3',
    provider: 'AvalAI',
    badge: 'تصویر',
    ownedBy: 'openai',
    category: 'image_generation',
    supportsImage: true,
    descriptionFa: 'ساخت تصویر داخل گفتگو با پرامپت متنی',
    descriptionEn: 'Generate images inside chat from text prompts'
  }
];

export const MODE_TITLES = {
  chat: { titleFa: 'گفتگو', titleEn: 'Chat' },
  image_generation: { titleFa: 'تولید تصویر', titleEn: 'Image generation' },
  completion: { titleFa: 'تکمیل متن', titleEn: 'Completion' },
  embedding: { titleFa: 'امبدینگ', titleEn: 'Embedding' },
  video_generation: { titleFa: 'تولید ویدیو', titleEn: 'Video generation' },
  audio_transcription: { titleFa: 'رونویسی صدا', titleEn: 'Audio transcription' },
  audio_speech: { titleFa: 'تبدیل متن به گفتار', titleEn: 'Text to speech' },
  ocr: { titleFa: 'OCR', titleEn: 'OCR' },
  moderation: { titleFa: 'مدراسیون', titleEn: 'Moderation' },
  rerank: { titleFa: 'رتبه‌بندی', titleEn: 'Rerank' },
  search: { titleFa: 'جستجو', titleEn: 'Search' }
};

const MODE_ORDER = [
  'chat',
  'image_generation',
  'completion',
  'embedding',
  'video_generation',
  'audio_transcription',
  'audio_speech',
  'ocr',
  'moderation',
  'rerank',
  'search'
];

export const MODEL_CATEGORIES = [
  { key: 'chat', titleFa: 'گفتگو', titleEn: 'Chat' },
  { key: 'image_generation', titleFa: 'تولید تصویر', titleEn: 'Image generation' }
];

export const DEFAULT_CHAT_MODEL_KEY = 'gpt-5.5';

export const FALLBACK_PICKER_MODELS = [...CHAT_MODELS, ...IMAGE_MODELS.filter((model) => model.key !== 'dall-e-3')];

const CHAT_MODEL_STORAGE_KEY = 'risman.chat.model';
const IMAGE_MODEL_STORAGE_KEY = 'risman.image.model';

export const toPickerModels = (catalog) =>
  sortByPopularity(
    (Array.isArray(catalog) ? catalog : [])
      .filter((model) => model?.modelId)
      .map((model) => ({
        key: model.modelId,
        name: model.displayName || model.modelId,
        provider: model.provider || 'AvalAI',
        badge: model.ownedBy || '',
        ownedBy: model.ownedBy || '',
        category: model.mode || 'chat',
        supportsImage: (model.mode || 'chat') === 'image_generation',
        descriptionFa: model.descriptionFa || '',
        descriptionEn: model.descriptionEn || '',
        allowed: model.allowed !== false,
        lockedReason: model.lockedReason || null
      }))
  );

export const resolveCatalogModels = (models) =>
  Array.isArray(models) && models.length > 0 ? models : FALLBACK_PICKER_MODELS;

export const getDefaultModeForKind = (kind) => (kind === 'image' ? 'image_generation' : 'chat');

export const getModelsForKind = (kind, models) => resolveCatalogModels(models);

export const getQuickModels = (kind, models) => {
  const all = resolveCatalogModels(models);
  const mode = getDefaultModeForKind(kind);
  const filtered = all.filter((model) => (model.category || 'chat') === mode);
  return (filtered.length ? filtered : all).slice(0, 4);
};

export const getCategoriesFromModels = (models) => {
  const used = new Set(resolveCatalogModels(models).map((model) => model.category || 'chat'));
  const known = MODE_ORDER.filter((key) => used.has(key)).map((key) => ({
    key,
    titleFa: MODE_TITLES[key]?.titleFa || key,
    titleEn: MODE_TITLES[key]?.titleEn || key
  }));
  const extras = [...used]
    .filter((key) => !MODE_ORDER.includes(key))
    .sort()
    .map((key) => ({
      key,
      titleFa: MODE_TITLES[key]?.titleFa || key,
      titleEn: MODE_TITLES[key]?.titleEn || key
    }));
  return [...known, ...extras];
};

export const getDefaultModelForKind = (kind, models) => {
  const all = resolveCatalogModels(models);
  const mode = getDefaultModeForKind(kind);
  const preferred = kind === 'image' ? DEFAULT_IMAGE_MODEL_KEY : DEFAULT_CHAT_MODEL_KEY;
  const inMode = all.filter((model) => (model.category || 'chat') === mode);
  const hasLocks = all.some((model) => model.allowed === false);
  const allowedInMode = hasLocks ? inMode.filter((model) => model.allowed !== false) : inMode;
  const pool = allowedInMode.length ? allowedInMode : inMode;

  if (pool.some((model) => model.key === preferred)) {
    return preferred;
  }

  return pool[0]?.key || all.find((model) => model.allowed !== false)?.key || all[0]?.key || preferred;
};

export const getModelByKey = (kind, key, models) => {
  const all = resolveCatalogModels(models);
  const match = all.find((model) => model.key === key);
  if (match && match.allowed !== false) {
    return match;
  }

  const fallbackKey = getDefaultModelForKind(kind, all);
  return all.find((model) => model.key === fallbackKey) || match || all[0];
};

export const resolveImageModelForReferences = (modelKey, hasReferences, models) => {
  if (!hasReferences) {
    return modelKey;
  }

  const current = String(modelKey || '').trim().toLowerCase();
  if (!current.startsWith('dall-e')) {
    return modelKey;
  }

  const all = resolveCatalogModels(models);
  if (all.some((model) => model.key === DEFAULT_IMAGE_EDIT_MODEL_KEY)) {
    return DEFAULT_IMAGE_EDIT_MODEL_KEY;
  }

  return all.find((model) => String(model.key || '').startsWith('gpt-image'))?.key || modelKey;
};

export const modelSupportsImage = (modelKey, models) => {
  const all = resolveCatalogModels(models);
  return Boolean(all.find((model) => model.key === modelKey)?.supportsImage);
};

export const loadStoredModel = (kind, models) => {
  const all = resolveCatalogModels(models);
  const hasLocks = all.some((model) => model.allowed === false);
  let stored = null;
  try {
    const storageKey = kind === 'image' ? IMAGE_MODEL_STORAGE_KEY : CHAT_MODEL_STORAGE_KEY;
    stored = window.localStorage.getItem(storageKey);
  } catch {
    // ignore
  }

  const storedModel = stored ? all.find((model) => model.key === stored) : null;
  if (storedModel && (!hasLocks || storedModel.allowed !== false)) {
    return stored;
  }

  const next = getDefaultModelForKind(kind, all);
  if (hasLocks && next && next !== stored) {
    storeSelectedModel(kind, next);
  }
  return next;
};

export const storeSelectedModel = (kind, key) => {
  try {
    const storageKey = kind === 'image' ? IMAGE_MODEL_STORAGE_KEY : CHAT_MODEL_STORAGE_KEY;
    window.localStorage.setItem(storageKey, key);
  } catch {
    // ignore
  }
};

const OWNED_BY_LABELS = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  google: 'Google',
  xai: 'xAI',
  meta: 'Meta',
  mistralai: 'Mistral',
  moonshot: 'Moonshot',
  zai: 'Z.ai',
  deepseek: 'DeepSeek',
  cohere: 'Cohere',
  perplexity: 'Perplexity'
};

export const formatOwnedBy = (ownedBy) => {
  const value = String(ownedBy || '').trim();
  if (!value) {
    return '';
  }

  return (
    OWNED_BY_LABELS[value.toLowerCase()] ||
    value
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );
};

const OWNER_POPULARITY = {
  openai: 100,
  anthropic: 96,
  google: 92,
  xai: 88,
  deepseek: 80,
  moonshot: 74,
  alibaba: 70,
  bfl: 78,
  zai: 58,
  meta: 55,
  'mistral ai': 50,
  mistralai: 50,
  runwayml: 62,
  bytedance: 58,
  minimax: 48,
  perplexity: 46,
  nvidia: 36,
  cohere: 38
};

const FAMILY_POPULARITY = [
  [/^gpt-image/, 96],
  [/^dall-e-3\b/, 90],
  [/^dall-e/, 72],
  [/^gpt-5/, 95],
  [/^gpt-4o/, 82],
  [/^gpt-4\.1/, 78],
  [/^gpt-4/, 55],
  [/^o3\b/, 70],
  [/^o4/, 68],
  [/^claude-opus/, 93],
  [/^claude-sonnet/, 90],
  [/^claude-haiku/, 72],
  [/^claude-fable/, 76],
  [/^gemini-3.*-pro/, 91],
  [/^gemini-3/, 88],
  [/^gemini-2\.5-pro/, 84],
  [/^gemini-2\.5/, 80],
  [/^gemini-2/, 60],
  [/^imagen-4/, 78],
  [/^imagen/, 68],
  [/^grok-4/, 86],
  [/^grok-3/, 70],
  [/^deepseek-v4/, 82],
  [/^deepseek/, 72],
  [/^kimi-k3/, 78],
  [/^kimi/, 68],
  [/^qwen3\.8/, 76],
  [/^qwen3/, 66],
  [/^qwen/, 50],
  [/^flux\.?2/, 84],
  [/^flux/, 74],
  [/^seedream/, 70],
  [/^glm-5/, 56],
  [/^llama-4/, 60],
  [/^llama/, 48],
  [/^mistral/, 50]
];

const popularityScore = (modelId, ownedBy) => {
  const id = String(modelId || '').trim().toLowerCase();
  if (!id) {
    return 0;
  }

  const owner = String(ownedBy || '').trim().toLowerCase();
  let score = (OWNER_POPULARITY[owner] || 26) * 12;
  const family = FAMILY_POPULARITY.find(([pattern]) => pattern.test(id));
  score += (family ? family[1] : 18) * 22;

  const cleaned = id.replace(/\d{4}-\d{2}-\d{2}/g, '').replace(/-\d{4,8}$/, '');
  const version = cleaned.match(/(\d+)(?:\.(\d+))?/);
  if (version) {
    const major = Number(version[1]);
    const minor = Number(version[2] || 0);
    if (major < 2000) {
      score += major * 10 + Math.min(minor, 20);
    }
  }

  if (
    /\d{4}-\d{2}-\d{2}/.test(id) ||
    /preview|experimental|alpha/.test(id) ||
    /-\d{4,8}$/.test(id)
  ) {
    score -= 420;
  }
  if (id.includes('-nano')) {
    score -= 70;
  } else if (id.includes('-mini') || id.includes('-lite')) {
    score -= 32;
  }
  if (id.includes('highspeed') || id.includes('non-reasoning')) {
    score -= 22;
  }
  if (id.includes('-codex')) {
    score -= 12;
  }

  const tokenCount = id.split('-').filter(Boolean).length;
  if (tokenCount <= 2) {
    score += 48;
  } else if (tokenCount <= 3) {
    score += 18;
  } else if (tokenCount >= 6) {
    score -= 40;
  }

  score -= Math.max(0, id.length - 24) * 3;
  return score;
};

export const sortByPopularity = (models) =>
  [...models].sort((left, right) => {
    const delta =
      popularityScore(right.key || right.modelId, right.ownedBy) -
      popularityScore(left.key || left.modelId, left.ownedBy);
    if (delta !== 0) {
      return delta;
    }
    return String(left.key || left.modelId || '').localeCompare(String(right.key || right.modelId || ''));
  });

export const sortModelIdsByPopularity = (modelIds, catalogModels = []) => {
  const ownedByById = new Map();
  catalogModels.forEach((model) => {
    const id = String(model?.key || model?.modelId || '').trim();
    if (id) {
      ownedByById.set(id.toLowerCase(), model.ownedBy || '');
    }
  });

  return [...modelIds].sort((left, right) => {
    const leftId = String(left || '');
    const rightId = String(right || '');
    const delta =
      popularityScore(rightId, ownedByById.get(rightId.toLowerCase())) -
      popularityScore(leftId, ownedByById.get(leftId.toLowerCase()));
    if (delta !== 0) {
      return delta;
    }
    return leftId.localeCompare(rightId);
  });
};

export const getOwnedByOptions = (models) => {
  const seen = new Set();
  const options = [];
  for (const model of models) {
    const ownedBy = String(model.ownedBy || model.badge || '').trim();
    if (!ownedBy || seen.has(ownedBy.toLowerCase())) {
      continue;
    }
    seen.add(ownedBy.toLowerCase());
    options.push(ownedBy);
  }
  return options.sort((left, right) => formatOwnedBy(left).localeCompare(formatOwnedBy(right)));
};
